/**
 * Shim Capacitor — sostituisce il monaca-cordova-loader.
 *
 * Con Capacitor (server.url remoto) il bridge nativo, cordova.js e il JS di
 * tutti i plugin Cordova vengono INIETTATI automaticamente nella pagina dalla
 * WebView: qui non va caricato nessun cordova.js (il vecchio loader Monaca
 * faceva document.write di cordova.js — rimosso).
 *
 * Restano solo gli shim di compatibilità per il codice esistente.
 */
(function () {

  function isNative() {
    return !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
  }

  function capPlugin(name) {
    return window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins[name];
  }

  // --- navigator.splashscreen (era cordova-plugin-splashscreen) ---
  // Lo splash nativo si chiude da solo all'avvio (launchAutoHide), quindi
  // hide/show diventano no-op sicuri che inoltrano a @capacitor/splash-screen.
  if (!navigator.splashscreen) {
    navigator.splashscreen = {
      hide: function () {
        var p = capPlugin('SplashScreen');
        if (p) { try { p.hide(); } catch (e) {} }
      },
      show: function () {
        var p = capPlugin('SplashScreen');
        if (p) { try { p.show({ autoHide: false }); } catch (e) {} }
      }
    };
  }

  // --- stub monaca (il runtime Monaca non esiste più) ---
  window.monaca = window.monaca || {};
  monaca.isAndroid = /Android/i.test(navigator.userAgent);
  monaca.isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  monaca.baseUrl = location.origin + '/';
  monaca.isDeviceReady = false;
  monaca.splashScreen = {
    hide: function () { navigator.splashscreen.hide(); }
  };
  document.addEventListener('deviceready', function () {
    monaca.isDeviceReady = true;
  }, false);

  // --- preview nel browser (senza app nativa) ---
  // Capacitor emette 'deviceready' quando i plugin Cordova sono pronti; nel
  // browser normale non arriverebbe mai, quindi lo simuliamo per il preview web.
  if (!isNative()) {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(function () {
        if (!window.cordova) {
          try { document.dispatchEvent(new Event('deviceready')); } catch (e) {}
        }
      }, 50);
    });

    // Fallback di cordova-sqlite-storage per il preview web: la tabella
    // chiave/valore `info` è emulata su localStorage, tutto il resto
    // (download, ecc.) risponde con risultati vuoti senza crashare.
    if (!window.sqlitePlugin) {
      var LS_KEY = 'ty_websql_info';

      function readInfo() {
        try { return JSON.parse(localStorage.getItem(LS_KEY)) || {}; } catch (e) { return {}; }
      }
      function writeInfo(obj) {
        try { localStorage.setItem(LS_KEY, JSON.stringify(obj)); } catch (e) {}
      }
      function makeResult(rowsArr, rowsAffected) {
        return {
          rowsAffected: rowsAffected || 0,
          insertId: 0,
          rows: {
            length: rowsArr.length,
            item: function (i) { return rowsArr[i]; }
          }
        };
      }

      var fakeTx = {
        executeSql: function (sql, params, ok, fail) {
          params = params || [];
          var s = String(sql).replace(/\s+/g, ' ').trim().toUpperCase();
          var result = makeResult([]);
          try {
            if (s.indexOf('CREATE TABLE') === 0) {
              result = makeResult([]);
            } else if (/INSERT OR REPLACE INTO INFO/.test(s)) {
              var info = readInfo();
              info[params[0]] = params[1];
              writeInfo(info);
              result = makeResult([], 1);
            } else if (/DELETE FROM INFO WHERE KEY/.test(s)) {
              var infoD = readInfo();
              delete infoD[params[0]];
              writeInfo(infoD);
              result = makeResult([], 1);
            } else if (/FROM INFO WHERE KEY/.test(s)) {
              var infoS = readInfo();
              var has = Object.prototype.hasOwnProperty.call(infoS, params[0]);
              if (/COUNT\(\*\)/.test(s)) {
                result = makeResult([{ count: has ? 1 : 0, value: has ? infoS[params[0]] : null }]);
              } else {
                result = has ? makeResult([{ key: params[0], value: infoS[params[0]] }]) : makeResult([]);
              }
            }
            // qualsiasi altra query (download, ecc.): risultato vuoto
            if (ok) ok(fakeTx, result);
          } catch (e) {
            if (fail) fail(fakeTx, e);
          }
        }
      };

      var fakeDb = {
        transaction: function (fn, onError, onSuccess) {
          setTimeout(function () {
            try {
              fn(fakeTx);
              if (onSuccess) onSuccess();
            } catch (e) {
              if (onError) onError(e);
            }
          }, 0);
        },
        readTransaction: function (fn, onError, onSuccess) {
          fakeDb.transaction(fn, onError, onSuccess);
        },
        close: function () {}
      };

      window.sqlitePlugin = {
        openDatabase: function () { return fakeDb; }
      };
    }
  }

})();
